import React, { Component } from 'react';
import { Button, FormGroup, TextArea, TextInput, Loading } from 'carbon-components-react';
import { DocumentExport16 } from '@carbon/icons-react/lib/';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import FileDownLoadButton from '../common/FileDownloadButton';
import { Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import Email16 from '@carbon/icons-react/lib/email/16'; //C3_Incident_Report_Email_Triggering_Issue

import { showNotification } from '../../helpers/notification/BaseNotification';
import { getSuccess, getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { api, dynamic } from '../../helpers/api/api';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import { IsEditable } from '../../helpers/authorization/Policies';
import EmailChips from '../../helpers/EmailChips';
import { Online, Offline } from '../common/OnLineOffLine';

const incidentTabReportModel = {
  id: null,
  noInjured: null,
  injuredPeople: [], // array di IncidentInjuredPerson
  eventCause: '',
  actions: '',
  dueDate: null,
  mailBodyReport: null,
  mailSubjectReport: null,
  maskedValue: false, //RITM0946001 - Anonimizzazione Modulo Incident
};
export default class IncidentTabReport extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.updateState = this.updateState.bind(this);
    // this.handleChangeCombo = this.handleChangeCombo.bind(this);
    this.state = {
      ...this.initialState(props),
    };
  }

  componentDidMount() {
    this.getContractType();
    this.getShiftDuration();
    this.getInjurySource();
    this.getInjuryClass();
    this.getBodyPart();
  }

  getBodyPart() {
    dynamic
      .getAll('bodypart', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appBodyPart: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.BODYPART, apioperation.GET));
      })
      .finally(() => {});
  }

  getInjuryClass() {
    dynamic
      .getAll('injuryclass', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appInjuryClass: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INJURYCLASS, apioperation.GET));
      })
      .finally(() => {});
  }

  getInjurySource() {
    dynamic
      .getAll('injurysource', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appInjurySource: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INJURYSOURCE, apioperation.GET));
      })
      .finally(() => {});
  }

  getContractType() {
    dynamic
      .getAll('contracttype', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appContractType: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CONTRACTTYPE, apioperation.GET));
      })
      .finally(() => {});
  }

  getShiftDuration() {
    dynamic
      .getAll('shiftduration', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appShiftDuration: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SHIFDURATION, apioperation.GET));
      })
      .finally(() => {});
  }

  initialState = (props) => {
    const initialState = {
      keyModal: `modal_${new Date().getTime()}`,
      editModel: null,
      isEditModal: false,
      isOpenModal: false,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,
      isLoadingReportFile: false,
      incidentModel: {
        ...incidentTabReportModel,
      },
      isDisabled: true,
    };
    if (props.incidentEditModel) {
      initialState.incidentModel = { ...props.incidentEditModel };
      initialState.isDisabled = !IsEditable(
        'Incident',
        'Reporting',
        props.user,
        props.incidentEditModel.status.id,
        'Report',
        props.incidentEditModel
      );
    }
    return initialState;
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  updateStateDP = (inputName, inputValue, objName) => {
    this.setState(
      (prevState) => ({
        [objName]: {
          ...prevState[objName],
          [inputName]: inputValue,
        },
      }),
      () => {
        this.initialState(inputName, inputValue);
      }
    );
  };

  selectTab = (index) => {
    this.props.selectTab(index);
  };

  toggleModal = (open) => {
    this.setState({ isOpenModal: open });
  };

  addNewPerson = () => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    this.setState({ isEditModal: false, isOpenModal: true, editModel: null });
  };

  editModal = (id) => {
    this.setState({ keyModal: `modal_${new Date().getTime()}` });
    this.setState((prevState) => {
      const item = prevState.incidentModel.injuredPeople.find((el) => el.id === id);
      return { editModel: item, isEditModal: true, isOpenModal: true };
    });
  };

  handleSaveModal = (data) => {
    try {
      if (data == null) return;

      const oldinjuredPeople = this.state.incidentModel.injuredPeople || [];

      if (this.state.isEditModal) {
        // edit
        const { id } = data;
        const indexElement = oldinjuredPeople.findIndex((el) => el.id === id);
        if (indexElement > -1) {
          const newinjuredPeople = [...oldinjuredPeople];
          newinjuredPeople[indexElement] = data;
          this.updateState('injuredPeople', newinjuredPeople, 'incidentModel');
        } else {
          showNotification.error();
        }
      } else {
        // insert
        const dataObj = { ...data };
        dataObj.idIncident = this.props.incidentEditModel.id;
        dataObj.id = uuid(); // id IncidentInjuredPerson
        dataObj.toSave = true; // solo gli injured appena creati possono essere modificati
        const newinjuredPeople = oldinjuredPeople.concat([dataObj]);
        this.updateState('injuredPeople', newinjuredPeople, 'incidentModel');
      }

      this.setState({ isOpenModal: false });
    } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, 'handleSaveModal'));
    }
  };

  getInjuryTypeName = (id) => {
    const element = this.props.appInjuryType.find((el) => el.id === id);
    return element ? element.name : '';
  };

  saveTabReport = () => {
    if (this.validator.allValid()) {
      this.props.isSubmitted(true);

      const datiForm = this.state.incidentModel;

      api
        .put('/incident/', datiForm, `${datiForm.id}/report`)
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(`${entitiesLabels.SUCCESS}`,
              this.state.incidentModel.id != null
                ? `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${datiForm.incidentReportId} ${getSuccess('report distribution', apioperation.PUT)}`
                : getSuccess(entitiesLabels.INCIDENT, apioperation.POST)
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.POST));
        })
        .finally(() => {
          this.props.isSubmitted(false);
        });
      this.props.updateCacheIncidentModel(datiForm, 'tabReport');
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
      `${entitiesLabels.INCIDENT} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  //C3_Incident_Report_Email_Triggering_Issue
  sendNotification = () => {
    this.props.isSubmitted(true);
    
    const datiForm = this.state.incidentModel;
  
      api
        .put('/incident/notification/send', datiForm)
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(`${entitiesLabels.SUCCESS}`,'Successfully sent');
            this.props.history.push('/incident');
          } else {
            showNotification.error(`${entitiesLabels.ERROR}`,
              getError('Unsuccessfully sent', entitiesLabels.INCIDENT, apioperation.POST)
            );
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.POST));
        })
        .finally(() => {
          this.props.isSubmitted(false);
        });
  };
  //End

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItem = () => {
    const id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });

    this.setState((prevState) => {
      const statusCopy = { ...prevState.incidentModel };
      statusCopy.injuredPeople = statusCopy.injuredPeople.filter((el) => el.id !== id);

      return {
        incidentModel: statusCopy,
        isDeleting: false,
        isOpenDeleteModal: false,
      };
    });
  };

  handleChangeRadio = (value, id, event) => {
    let v = null; 
    if (value === 'true') {
      v = true;
    } else if (value === 'false') {
      v = false;
    } else if (value === 'null') {
      v = null;
    }

    this.updateState(event.target.name, v, event.target.alt);
  };
  
  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;
    this.updateState(inputName, inputValue, objName);
  };

  render() {
    if (!this.props.incidentEditModel || !this.props.incidentEditModel.id) {
      return null;
    }

    this.validator.purgeFields(); // si usa quando ci sono validazioni condizionali tra più campi
    const validations = {
      // immediateActions: 
      //  this.validator.message('immediateActions', 
      //                         this.state.hocCardModel.immediateActions,
      //                         'required'),
      mailBodyReport: this.validator.message(
        'mailBodyReport',
        this.state.incidentModel.mailBodyReport,
        'required'
      ),
    };

    const rows = this.state.incidentModel.injuredPeople || [];
    // const injuredPersonModalProps = {
    //   key: this.state.keyModal,
    //   title: 'Injured Person',
    //   editModel: this.state.editModel,
    //   isOpenModal: this.state.isOpenModal,
    //   isEditModal: this.state.isEditModal,
    //   mode: this.state.isEditModal ? 2 : 0,
    //   appType: this.props.appType,
    //   appNationality: this.props.appCountry,
    //   appInjuryType: this.props.appInjuryType,
    //   appContractType: this.state.appContractType,
    //   appShiftDuration: this.state.appShiftDuration,
    //   appInjurySource: this.state.appInjurySource,
    //   appInjuryClass: this.state.appInjuryClass,
    //   appBodyPart: this.state.appBodyPart,
    //   toggleModal: this.toggleModal,
    //   save: this.handleSaveModal,
    // };

    const getNameById = (id) => {
      if (id == null) return '';
      const element = rows.find((el) => el.id === id);
      return element ? element.fullname : '';
    };

    // const confirmDelProps = () => ({
    //   idToDelete: this.state.idToDelete,
    //   nameItem: getNameById(this.state.idToDelete),
    //   isDeleting: this.state.isDeleting,
    //   open: this.state.isOpenDeleteModal, // open state
    //   onCloseConfirm: this.onCloseConfirm, // no click
    //   deleteItem: this.deleteItem, // yes click fn()
    // });

    return (
      <>
        <ConfirmAlertCustom 
          idToDelete={this.state.idToDelete} 
          nameItem={getNameById(this.state.idToDelete)} 
          isDeleting={this.state.isDeleting}
          open={this.state.isOpenDeleteModal}
          onCloseConfirm={this.onCloseConfirm}
          deleteItem={this.deleteItem}
        />
        <Loading active={this.state.isLoadingReportFile} withOverlay />
        <div className="bx--row">
          <div className="padding-progress-indicator-vertical hidden-box">
            <Menu>
              <Item section="reportincident">4.1 Report Distribution</Item>
            </Menu>
          </div>
          <div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
            <Section id="reportincident" className="section--title">
              <div className="bx--row section--title">
                {' '}
                <h3 className="title--medium--expressive selection-items-list-costum">
                  4.1 Report Distribution
                </h3>
                {' '}
                <Online>
                  <FileDownLoadButton
                    onError={(error) => {
                      showNotification.error(`${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.INCIDENT_REPORT, apioperation.DOWNLOAD)
                      );
                    }}
                    size="small"
                    className=" selection-items-list-costum bx--data-table-container-absolute  "
                    renderIcon={DocumentExport16}
                    iconDescription="Download Report"
                    title="Download Report"
                    kind="ghost"
                    apiUrl={`/incident/report/${this.state.incidentModel.id}`}
                    fileName={`Incident_Report_${this.state.incidentModel.incidentReportId}.pdf`}
                    onDownLoadStart={() => {
                      this.setState({
                        isLoadingReportFile: true,
                      });
                    }}
                    onDownLoadEnd={() => {
                      this.setState({
                        isLoadingReportFile: false,
                      });
                    }}
                  />
                </Online>
              </div>

              <div className="bx--row section--title">
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup legendText="Mail To* (Personal Email Addresses are not allowed​​)">
                    <EmailChips
                      value={this.state.incidentModel.mailTo || ''}
                      type="text"
                      onChange={(value) => this.updateState('mailTo', value, 'incidentModel')}
                      invalid={validations.mailTo != null}
                      disabled={this.state.isDisabled}
                      title="&#9888; Do Not use Personal Accounts"
                      masked={this.state.incidentModel.maskedValue} //RITM0946001 - Anonimizzazione Modulo Incident
                      // placeholder="Input mail To"
                    />

                    {/* <TextInput
                                        id="mailTo"
                                        name="mailTo"
                                        alt="incidentModel"
                                        placeholder="Input mailTo"
                                        value={this.state.incidentModel.mailTo || ''}
                                        onChange={this.handleChangeModel}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        invalid={validations.mailTo != null}
                                        disabled={this.state.isDisabled}
                                    /> */}
                    {validations.mailTo}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup legendText="Mail CC (Personal Email Addresses are not allowed​)">
                    <EmailChips
                      value={this.state.incidentModel.mailCc || ''}
                      type="text"
                      onChange={(value) => this.updateState('mailCc', value, 'incidentModel')}
                      disabled={this.state.isDisabled}
                      title="&#9888; Do Not use Personal Accounts"
                      masked={this.state.incidentModel.maskedValue} //RITM0946001 - Anonimizzazione Modulo Incident
                      // placeholder="Input mail Cc"
                    />
                    {/* <TextInput
                                        id="mailCc"
                                        name="mailCc"
                                        alt="incidentModel"
                                        placeholder="Input mailCc"
                                        value={this.state.incidentModel.mailCc || ''}
                                        onChange={this.handleChangeModel}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        invalid={validations.mailCc != null}
                                        disabled={this.state.isDisabled}
                                    /> */}
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row row-content">
                <div className="bx--col-lg-12">
                  <FormGroup legendText="Message* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                    <TextArea
                      maxLength={5000}
                      id="mailBodyReport"
                      placeholder="Input message"
                      value={this.state.incidentModel.mailBodyReport || ''}
                      onChange={(el) =>
                        this.updateState('mailBodyReport', el.target.value, 'incidentModel')
                      }
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={100}
                      disabled={this.state.isDisabled}
                      invalid={validations.mailBody != null}
                    />
                    {validations.mailBodyReport}
                  </FormGroup>
                </div>
              </div>
            </Section>
          </div>
        </div>
        <div className="bx--row">
          <Button
            onClick={() => this.selectTab(2)}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Prev Step
          </Button>
          <Button
            onClick={() => this.props.cancel()}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => this.saveTabReport()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="primary"
          >
            Save
          </Button>
          <Online>
            <Button
              disabled={this.state.incidentModel.idStatus !== 1}
              onClick={() => this.props.submitReport()}
              className="bx--col bx--btn--max-width"
              size="default"
              kind="primary"
            >
              Submit
            </Button>
          </Online>
          <Offline>
            <Button
              disabled
              onClick={() => this.props.submitReport()}
              className="bx--col bx--btn--max-width"
              size="default"
              kind="primary"
            >
              Submit
            </Button>
          </Offline>
          {/* C3_Incident_Report_Email_Triggering_Issue */}
          <Online>
          {IsEditable("Incident", "Reporting", this.props.user, this.props.incidentEditModel.status.id, "Report", this.props.incidentEditModel) ? (
            <Button
              disabled={(this.state.incidentModel.idStatus < 3 || (this.state.incidentModel.idStatus > 2 && this.state.incidentModel.isReportDistributed == true))} //C3_Incident_Report_Email_Triggering_Issue
              onClick={() => this.sendNotification()}
              renderIcon={Email16}
              size="default"
              kind="primary"
            >
              RESEND INCIDENT REPORT to DL
            </Button>) : null}
          </Online>
          {/* End */}
          <Button
            onClick={() => window.print()}
            disabled={this.state.isDisabled}
            className="bx--col bx--btn--max-width"
            size="default"
            kind="secondary"
          >
            Print
          </Button>
          <Button disabled className="bx--col bx--btn--max-width" size="default" kind="secondary">
            Next Step
          </Button>
        </div>
      </>
    );
  }
}

IncidentTabReport.propTypes = {
  cancel: PropTypes.func.isRequired,
  isSubmitted: PropTypes.func.isRequired,
  selectTab: PropTypes.func.isRequired,
  submitReport: PropTypes.func.isRequired,
  updateCacheIncidentModel: PropTypes.func.isRequired,
  appInjuryType: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      code: PropTypes.string,
      name: PropTypes.string,
      inUse: PropTypes.bool,
      createdBy: PropTypes.string,
      createdOn: PropTypes.instanceOf(Date),
      updatedBy: PropTypes.string,
      updatedOn: PropTypes.instanceOf(Date),
      validSince: PropTypes.instanceOf(Date),
      validUntil: PropTypes.instanceOf(Date),
      typology: PropTypes.string
    })).isRequired,
  incidentEditModel: PropTypes.shape({
      noInjured: PropTypes.string,
      injuredPeople: PropTypes.array,
      eventCause: PropTypes.string,
      actions: PropTypes.string,
      dueDate: PropTypes.instanceOf(Date),
      mailTo: PropTypes.string,
      mailCc: PropTypes.string,
      mailBodyReport: PropTypes.string,
      mailSubjectReport: PropTypes.string,
      processed: PropTypes.bool,
      id: PropTypes.string,
      progressiveId: PropTypes.number,
      incidentReportId: PropTypes.string,
      idStatus: PropTypes.number,
      status: PropTypes.object,
      idCompiler: PropTypes.string,
      idDataApprover: PropTypes.string,
      idDivisionManager: PropTypes.string,
    }).isRequired
};
